import React from 'react';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import PointsIcon from '@wix/da-ds/pkg/Icons/Points';
import DetailsRightSide from '../../layouts/DetailsRightSide';
const PriceWithPoints = ({ formattedDollarsPrice , pointsPrice  })=>{
    return /*#__PURE__*/ React.createElement(DetailsRightSide, {
        firstRow: formattedDollarsPrice && formattedDollarsPrice,
        secondRow: pointsPrice && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(PointsIcon, {
            size: IconSize.TINY,
            disableDefaultColors: true
        }), pointsPrice)
    });
};
PriceWithPoints.displayName = 'PriceWithPoints';
export default PriceWithPoints;
